module.exports = __webpack_public_path__ + "static/hifi3-f4bf4fdc7747c6bfa7ec7d26a13026d7.jpg";